export const ISSUE_TYPE_CONNECTIONS_CONFIGURATION_PROPERTY_KEY =
	'polaris.connections-configuration';
